import { createContext, useState } from "react";
import Loading from "../components/common/loading";
interface LayoutContextProps {
  showNotification: boolean;
  showSideBar: boolean;
  loadingPage: boolean;
  openNotification: () => void;
  closeNotification: () => void;
  closeSideBar: () => void;
  toggleSideBar: () => void;
  setLoadingPage: React.Dispatch<React.SetStateAction<boolean>>;
}

export const LayoutContext = createContext<LayoutContextProps | undefined>(undefined);

export const LayoutProvider = (props: { children: React.ReactNode }) => {
  //Dealing With Showing and Hiding Notification
  const [showNotification, setShowNotification] = useState(false);
  //Dealing With Showing and Hiding SideBar Mobile
  const [showSideBar, setShowSideBar] = useState(false);
  // Dealing loading whole page
  const [loadingPage, setLoadingPage] = useState(false);

  // short actions to display and hide layout modals
  const openNotification = () => setShowNotification(true);
  const closeNotification = () => setShowNotification(false);
  const toggleSideBar = () => setShowSideBar(!showSideBar);
  const closeSideBar = () => setShowSideBar(false);

  return (
    <LayoutContext.Provider
      value={{
        showNotification,
        openNotification,
        closeNotification,
        showSideBar,
        toggleSideBar,
        closeSideBar,
        loadingPage,
        setLoadingPage,
      }}
    >
      {props.children}
    </LayoutContext.Provider>
  );
};
